import WithRender from "../../templates/imageEditor/cutouts.html";
import { mapGetters } from "vuex";
import * as R from "ramda";

export default WithRender({
  data: function () {
    return {
      cutout: {
        left: 0,
        top: 0
      }
    };
  },
  computed: {
    ...mapGetters(["getCutouts", "getPOIEVariables"]),
    total: function () {
      return this.getCutouts.cutouts.length;
    },
    cutoutsObjects: function () {
      return this.getCutouts.cutouts;
    },
    enableCutouts: function () {
      return parseFloat(this.getPOIEVariables.enableCutouts);
    }
  },
  methods: {
    onEnter: function (event) {
      event.preventDefault();
    },
    addNewCutout: function (type) {
      this.$store.commit("addNewCutout", { itemType: type });
    },
    removeCutout: function (index) {
      this.$store.commit("removeCutout", index);
    }
  },
  watch: {
    cutoutsObjects: {
      handler: function (newData, oldData) {
        R.forEach(function (dosen) {
          dosen["offsetX"] = dosen["width"] / 2;
          dosen["offsetY"] = dosen["height"] / 2;
        }, this.getCutouts.cutouts);
      },
      deep: true
    }
  }
});
